import Modal from './accessibility';
import {watchAnimations} from '../utility/init-gsap';
import {smoother} from "../utility/gsap";
import {scrollToEl} from "../utility/utils";

class TD_POST_FEED {
  constructor(feedEl) {
    this.setBlockElements(feedEl);
    
    this.setQueryVarsOnLoad();

    this.watchEvents();

    this.layout = this.els.feedWrap.dataset.layout ? this.els.feedWrap.dataset.layout : 'grid'; // Default to grid layout
    this.filtersOpen = false;
  }

  is_desktop() {
    return window.matchMedia('(min-width: 992px)').matches;
  }

  setBlockElements(feedEl) {
    this.els = {};
    this.els.block = feedEl;
    this.els.feedWrap = this.els.block.querySelector('.post_feed__list');
    this.els.loadMoreButton = this.els.block.querySelector('.post_feed__load_more');
    this.els.search = this.els.block.querySelector('.post_feed__filters_search_input');
    this.els.searchSubmit = this.els.block.querySelector('.post_feed__filters_search_button');
    this.els.checkboxes = this.els.block.querySelectorAll('.checkbox_input');
    this.els.clearFiltersButton = this.els.block.querySelector('.post_feed__filters_clear');
    this.els.toggleFiltersButtons = this.els.block.querySelectorAll('.post_feed__filters_toggle, .post_feed__filters_close');
    this.els.filtersWrap = this.els.block.querySelector('.post_feed__filters');
    this.els.sortTrigger = this.els.block.querySelector('.post_feed__sorting_trigger');
    this.els.sortList = this.els.block.querySelector('.post_feed__sorting_options');
    this.els.sortOptions = this.els.block.querySelectorAll('.post_feed__sorting_options button');
    this.els.dropdownButtons = this.els.block.querySelectorAll('.post_feed__filters_group_label');
    this.setCardElements();
  }

  /**
   * Set Card Elements
   */
  setCardElements(){
    this.els.cards = this.els.feedWrap.querySelectorAll('.post_card');
  }

  setQueryVarsOnLoad() {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // keep original
    this.originalQueryVars = this.els.block.dataset;
    this.queryVars = { ...this.els.block.dataset };

    const csvToArray = (s) => (typeof s === 'string' && s.length ? s.split(',') : []);
    const norm = (s, d = '') => (s ? String(s).trim() : d);

    // ----- SEARCH -----
    if (params.has('s')) this.queryVars.s = norm(params.get('s'));
    else if (this.queryVars.s) this.queryVars.s = norm(this.queryVars.s);
    if (this.els.search && this.queryVars.s) this.els.search.value = this.queryVars.s;

    // ----- TAXONOMY (same as before) -----
    const taxTermsMap = new Map();
    const taxCheckboxes = this.els.block.querySelectorAll('.post_feed__filters_taxonomy_checkbox');
    taxCheckboxes.forEach(cb => {
      const tax = cb.dataset.taxonomy;
      const term = cb.dataset.termSlug;
      if (!tax || !term) return;
      const csv = params.get(tax);
      if (csv) {
        const terms = csvToArray(csv);
        if (terms.includes(term)) {
          cb.checked = true;
          if (!taxTermsMap.has(tax)) taxTermsMap.set(tax, new Set());
          taxTermsMap.get(tax).add(term);
        }
      }
    });

    if (taxTermsMap.size > 0) {
      this.queryVars.taxQueryTaxonomies = Array.from(taxTermsMap.keys());
      this.queryVars.taxQueryTerms = this.queryVars.taxQueryTaxonomies.map(tax => Array.from(taxTermsMap.get(tax)));
    } else if (this.queryVars.taxQueryTaxonomies) {
      this.queryVars.taxQueryTaxonomies = this.queryVars.taxQueryTaxonomies.split(':');
      this.queryVars.taxQueryTerms = (this.queryVars.taxQueryTerms || '').split(':').map(g => csvToArray(g));
      this.queryVars.taxQueryTerms.forEach((terms, i) => {
        const tax = this.queryVars.taxQueryTaxonomies[i];
        terms.forEach(termSlug => {
          const cb = this.els.block.querySelector(`.post_feed__filters_taxonomy_checkbox[data-taxonomy="${tax}"][data-term-slug="${termSlug}"]`);
          if (cb) cb.checked = true;
        });
      });
    } else {
      this.queryVars.taxQueryTaxonomies = [];
      this.queryVars.taxQueryTerms = [];
    }

    // ----- META: check boxes using ?mcb=ID,ID,ID -----
    const idsCsv = params.get('mcb') || '';
    const idsSet = new Set(csvToArray(idsCsv));
    const metaCbs = this.els.block.querySelectorAll('.post_feed__filters_meta_checkbox');

    // If URL has mcb -> use it; else, fall back to dataset defaults (if any)
    if (idsSet.size > 0) {
      metaCbs.forEach(cb => { cb.checked = idsSet.has(cb.id); });
    } else if (this.queryVars.metaQueryFields) {
      // Fallback: dataset colon lists to pre-check
      const dFields   = (this.queryVars.metaQueryFields || '').split(':');
      const dValues   = (this.queryVars.metaQueryValues || '').split(':');   // CSV per group
      const dCompares = (this.queryVars.metaQueryCompares || '').split(':');
      const dTypes    = (this.queryVars.metaQueryTypes || '').split(':');

      dFields.forEach((field, i) => {
        const vals = csvToArray(dValues[i] || '');
        const cmp  = (dCompares[i] || '=').toUpperCase();
        const typ  = (dTypes[i] || 'CHAR').toUpperCase();
        vals.forEach(val => {
          const cb = this.els.block.querySelector(
            `.post_feed__filters_meta_checkbox[data-meta-field="${field}"][data-meta-value="${val}"][data-meta-compare="${cmp}"][data-meta-type="${typ}"]`
          );
          if (cb) cb.checked = true;
        });
      });
    }

    // Initialize job-specific filters
    this.queryVars.jobDepartments = [];
    this.queryVars.jobLocations = [];
    // Now (re)build the metaQuery arrays from the currently-checked boxes
    this.buildMetaQueryFromChecked();

    // Update dropdown labels
    this.updateDropDownLabelCurrentDisplay();

    // Clear button
    this.setClearButtonVisibility();
  }


  isOnlyFeedOnPage() {
    return document.querySelectorAll('.post_feed').length === 1;
  }

  updateSearchResults() {
    this.els.searchSubmit.blur();
        
    // Update the queryVars with the search input value
    this.queryVars.s = this.els.search.value;

    // Update the url with the s query param
    if(this.isOnlyFeedOnPage()){
      const url = new URL(window.location.href);
      if(this.queryVars.s){
        url.searchParams.set('search', this.els.search.value); 
      }
      else {
        url.searchParams.delete('search');
      }
      window.history.replaceState({}, '', url.toString());
    }

    this.ajaxLoadMore(false, true);
  }

  watchEvents(){
    // Resize events
    let resizeDebouncer = null;
    window.addEventListener('resize', () => {
      if(resizeDebouncer) clearTimeout(resizeDebouncer);
      resizeDebouncer = setTimeout(() => {
        if(this.els.filtersWrap){
          // On desktop, close the filters if they're open
          if(this.is_desktop()) {
            if(this.filtersOpen){
              this.closeMobileFilters();
            }
  
            if(document.querySelector('.site-header').classList.contains('force-hide-header')){
              document.querySelector('.site-header').classList.remove('force-hide-header');
            }
  
            this.els.filtersWrap.setAttribute('aria-hidden', 'false');
          }
        } 
      }, 100);
    });

    // Load More
    if(this.els.loadMoreButton){
      this.els.loadMoreButton.addEventListener('click', () => {
        this.ajaxLoadMore(true);
      });
    }

    // Search
    if(this.els.search && this.els.searchSubmit){
      this.els.search.addEventListener('keyup', (event) => {
        if(event.key === 'Enter'){
          this.updateSearchResults();
        }
      });

      this.els.searchSubmit.addEventListener('click', (event) => {
        this.updateSearchResults();
      });
    }

    // Checkboxes
    if(this.els.checkboxes && this.els.checkboxes.length){
      this.els.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', (event) => {
          const filterType = checkbox.dataset.filterType;
          // Meta Query Filters
          if(filterType === 'meta_query'){
            // this.toggleQueryVars('meta', checkbox.dataset?.metaField, checkbox.dataset?.metaValue, checkbox, null, true, {compare: checkbox.dataset?.metaCompare, type: checkbox.dataset?.metaType});
            // Rebuild the aligned meta arrays from current UI
            this.buildMetaQueryFromChecked();
            // Keep URL in sync with which boxes are checked
            this.syncMetaCheckboxesToUrl();
            // Update dropdown labels
              this.updateDropDownLabelCurrentDisplay();
            // Refresh
            this.ajaxLoadMore(false, true);
          }
          // Taxonomy Filters
          else if(filterType === 'taxonomy'){
            // Get the taxonomy and term from the checkbox
            const taxonomy = checkbox.dataset.taxonomy;
            const term = checkbox.dataset.termSlug;

            // this.toggleQueryVars('tax', taxonomy, term, checkbox);
            this.toggleTaxQueryVars(taxonomy, term, checkbox);
            // Update dropdown labels
            this.updateDropDownLabelCurrentDisplay();
          }
          // Job Filters (careers)
          else if(filterType === 'job'){
            const key = checkbox.dataset.jobKey; // 'department' or 'location'
            const value = checkbox.dataset.jobValue;
            this.toggleJobFilter(key, value, checkbox);
            // Update dropdown labels
            this.updateDropDownLabelCurrentDisplay();
          }
        });
      });
    }

    // Clear Filters
    if(this.els.clearFiltersButton){
      this.els.clearFiltersButton.addEventListener('click', (event) => {
        this.els.clearFiltersButton.blur();
        this.els.clearFiltersButton.setAttribute('aria-hidden', 'true');

        // Clear search input
        if(this.els.search){
          this.els.search.value = '';
          this.queryVars.s = '';
        }

        // Uncheck all checkboxes
        if(this.els.checkboxes && this.els.checkboxes.length){
          this.els.checkboxes.forEach(checkbox => {
            checkbox.checked = false;
            if(checkbox.dataset.filterType === 'meta_query'){
              // Rebuild the aligned meta arrays from current UI
              this.buildMetaQueryFromChecked();
              // Keep URL in sync with which boxes are checked
              this.syncMetaCheckboxesToUrl();
              // Update dropdown labels
              this.updateDropDownLabelCurrentDisplay();
            }
            else if(checkbox.dataset.filterType === 'taxonomy'){
              this.toggleTaxQueryVars(checkbox.dataset.taxonomy, checkbox.dataset.termSlug, checkbox, false);
              // Update dropdown labels
              this.updateDropDownLabelCurrentDisplay();
            }
            else if(checkbox.dataset.filterType === 'job'){
              // Reset job filters
              this.queryVars.jobDepartments = [];
              this.queryVars.jobLocations = [];
              // Update dropdown labels
              this.updateDropDownLabelCurrentDisplay();
            }
          });
        }

        // Update the url to remove all query params
        const url = new URL(window.location.href);
        url.searchParams.delete('search'); // Clear all search params
        window.history.replaceState({}, '', url.toString());

        // Load more posts with updated query vars
        this.ajaxLoadMore(false, true);
      });
    }

    // Dropdown Toggles
    if(this.els.dropdownButtons && this.els.dropdownButtons.length){
      this.els.dropdownButtons.forEach(button => {
        const controlsId = button.getAttribute('aria-controls');
        const optionsEl = this.els.block.querySelector(`#${controlsId}`);
        button.addEventListener('click', (event) => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
          if(optionsEl){
            if(isExpanded){
              optionsEl.setAttribute('aria-hidden', 'true');
              optionsEl.classList.remove('active');
            }
            else {
              optionsEl.setAttribute('aria-hidden', 'false');
              optionsEl.classList.add('active');
            }
          }

          // If there is another dropdown open, close it
          this.els.dropdownButtons.forEach(otherButton => {
            if(otherButton !== button){
              const otherControlsId = otherButton.getAttribute('aria-controls');
              const otherOptionsEl = this.els.block.querySelector(`#${otherControlsId}`);
              otherButton.setAttribute('aria-expanded', 'false');
              if(otherOptionsEl){
                otherOptionsEl.setAttribute('aria-hidden', 'true');
                otherOptionsEl.classList.remove('active');
              }
            }
          });
        });

        // If clicking off a button or option, close the dropdown
        document.addEventListener('click', (event) => {
          if(!button.contains(event.target) && optionsEl && !optionsEl.contains(event.target) && optionsEl.classList.contains('active')){
            optionsEl.setAttribute('aria-hidden', 'true');
            optionsEl.classList.remove('active');
            button.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }

    // Toggle Filters Visibility
    if(this.els.toggleFiltersButtons.length){
      this.els.toggleFiltersButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          button.blur();
          this.filtersOpen = !this.filtersOpen;

          if(this.els.filtersWrap.classList.contains('active')){
            this.closeMobileFilters();
          }
          else {
            // move this.els.filtersWrap to the end of the body for easier fixed positioning
            if(this.els.filtersWrap.parentNode !== document.body){
              document.body.appendChild(this.els.filtersWrap);
            }

            this.els.filtersWrap.classList.add('active');
            this.els.filtersWrap.setAttribute('aria-hidden', 'false');
            this.els.toggleFiltersButtons.forEach(btn => btn.setAttribute('aria-expanded', 'true'));

            document.querySelector('.site-header').classList.add('force-hide-header');

            if(smoother){
              smoother.paused(true);
            }
            else {
              document.body.classList.add('scroll-lock');
            }

            // Handles trapping focus in filters modal
            Modal.open(this.els.filtersWrap);

            this.els.filtersWrap.focus();
          }
        });
      });
    }

    // Sort Menu Toggle
    if(this.els.sortTrigger && this.els.sortList){
      this.els.sortTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.els.sortList.classList.toggle('active');
        this.els.sortTrigger.setAttribute('aria-expanded', this.els.sortList.classList.contains('active') ? 'true' : 'false');
      });

      // Sort Select Change
      if(this.els.sortOptions && this.els.sortOptions.length){
        this.els.sortOptions.forEach(option => {
          option.addEventListener('click', (event) => {
            event.preventDefault();

            // If already set, just close the sort list
            if(option.classList.contains('active')){
              this.els.sortList.classList.remove('active');
              this.els.sortTrigger.setAttribute('aria-expanded', 'false');
              return;
            }
            
            // Unset any previous option
            this.els.sortOptions.forEach(opt => {
              if(opt.classList.contains('active')){
                opt.classList.remove('active');
              }
            });

            option.classList.add('active');

            const sortValue = option.getAttribute('data-sort');
            this.queryVars.order = sortValue;

            // Update the url with the order query param
            if(this.isOnlyFeedOnPage()){
              const url = new URL(window.location.href);
              if(sortValue){
                url.searchParams.set('order', sortValue);
              }
              else {
                url.searchParams.delete('order');
              }
              window.history.replaceState({}, '', url.toString());
            }

            // Load more posts with updated query vars
            this.ajaxLoadMore(false, true);

            // Close the sort list
            this.els.sortList.classList.remove('active');
            this.els.sortTrigger.setAttribute('aria-expanded', 'false');
          });
        });
      }

      // If the user clicks outside the sort select, close it
      document.addEventListener('click', (event) => {
        if(!this.els.sortList.contains(event.target) && !this.els.sortTrigger.contains(event.target) && this.els.sortList.classList.contains('active')){
          this.els.sortList.classList.remove('active');
          this.els.sortTrigger.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  // Builds aligned arrays from the currently-checked meta checkboxes.
  // Groups by (field, compare, type). Values are CSV strings per group.
  buildMetaQueryFromChecked() {
    const checked = Array.from(this.els.checkboxes).filter(checkbox => checkbox.checked && checkbox.classList.contains('post_feed__filters_meta_checkbox') && checkbox.dataset.filterType === 'meta_query');

    // relation: URL > DOM > default
    const url = new URL(window.location.href);
    const rel = (url.searchParams.get('m_relation') ||
                this.els.block.querySelector('.group-type-meta_query')?.dataset?.filterCompare ||
                'AND').toUpperCase();

    // temp grouping map keyed by "field|compare|type"
    const groups = new Map();

    checked.forEach(cb => {
      const field   = (cb.dataset.metaField || '').trim();
      const value   = (cb.dataset.metaValue || '').trim();
      const compare = (cb.dataset.metaCompare || '=').trim().toUpperCase();
      const type    = (cb.dataset.metaType || 'CHAR').trim().toUpperCase();
      if (!field || !value) return;

      const key = `${field}|${compare}|${type}`;
      if (!groups.has(key)) groups.set(key, { field, compare, type, values: new Set() });
      groups.get(key).values.add(value);
    });

    // Emit aligned arrays (values as CSV strings)
    this.queryVars.metaQueryRelation = rel;
    this.queryVars.metaQueryFields   = [];
    this.queryVars.metaQueryValues   = [];
    this.queryVars.metaQueryCompares = [];
    this.queryVars.metaQueryTypes    = [];

    for (const { field, compare, type, values } of groups.values()) {
      const arr = Array.from(values);
      const csv = arr.join(',');
      this.queryVars.metaQueryFields.push(field);
      this.queryVars.metaQueryValues.push(csv);
      // If multiple values in same group, force IN (WP-friendly). Otherwise, keep compare.
      this.queryVars.metaQueryCompares.push(arr.length > 1 ? 'IN' : compare);
      this.queryVars.metaQueryTypes.push(type);
    }
  }

  closeMobileFilters() {
    this.els.filtersWrap.classList.remove('active');
    this.els.filtersWrap.setAttribute('aria-hidden', 'true');
    this.els.toggleFiltersButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    document.querySelector('.site-header').classList.remove('force-hide-header');
    if(smoother){
      smoother.paused(false);
    }
    else {
      document.body.classList.remove('scroll-lock');
    }



    // ensure the search value is updated
    if(this.queryVars.s !== this.els.search.value){
      setTimeout(() => {
        this.updateSearchResults();
      }, 150);
    } 

    // Handles un-trapping focus in filters modal
    Modal.close(this.els.filtersWrap);
    Modal.setToFocusable(this.els.filtersWrap); // in case of resize to desktop

    // If the filters are at the end of the body, move to after this.els.toggleFiltersButtons
    if(this.els.filtersWrap.parentNode === document.body){
      const toggleButton = this.els.toggleFiltersButtons[0];
      if(toggleButton && toggleButton.parentNode){
        toggleButton.parentNode.insertBefore(this.els.filtersWrap, toggleButton.nextSibling);
      }
    }
  }

  toggleTaxQueryVars(taxonomy, term, checkbox = null, updateAjax = true) {
    // If the checkbox is checked, add it to the query vars
    if(checkbox.checked){
      if(!this.queryVars.taxQueryTaxonomies.includes(taxonomy)){
        this.queryVars.taxQueryTaxonomies.push(taxonomy);
        this.queryVars.taxQueryTerms.push([term]);
      }
      else {
        const index = this.queryVars.taxQueryTaxonomies.indexOf(taxonomy);
        this.queryVars.taxQueryTerms[index].push(term);
      }
    }
    else {
      // If the checkbox is unchecked, remove it from the query vars
      const index = this.queryVars.taxQueryTaxonomies.indexOf(taxonomy);
      if(index !== -1){
        const termIndex = this.queryVars.taxQueryTerms[index].indexOf(term);
        if(termIndex !== -1){
          this.queryVars.taxQueryTerms[index].splice(termIndex, 1);
          if(this.queryVars.taxQueryTerms[index].length === 0){
            this.queryVars.taxQueryTaxonomies.splice(index, 1);
            this.queryVars.taxQueryTerms.splice(index, 1);
          }
        }
      }
    }

    // Update the url with the tax query params
    if(this.isOnlyFeedOnPage()){
      const url = new URL(window.location.href);
      if(this.queryVars.taxQueryTaxonomies.length > 0){
        this.queryVars.taxQueryTaxonomies.forEach((taxonomy, index) => {
          url.searchParams.set(`${taxonomy}`, this.queryVars.taxQueryTerms[index].join(','));
        });
      }
      else {
        url.searchParams.delete(taxonomy);
      }
      window.history.replaceState({}, '', url.toString());
    }

    if(updateAjax){
      // Load more posts with updated query vars
      this.ajaxLoadMore(false, true);
    }
  }

  // Toggle job-specific filters for careers: department/location
  toggleJobFilter(key, value, checkbox = null, updateAjax = true) {
    if(!key || !value) return;
    const arrKey = key === 'department' ? 'jobDepartments' : (key === 'location' ? 'jobLocations' : null);
    if(!arrKey) return;
    if(!Array.isArray(this.queryVars[arrKey])) this.queryVars[arrKey] = [];

    const normVal = String(value).trim();
    const idx = this.queryVars[arrKey].findIndex(v => v.toLowerCase() === normVal.toLowerCase());
    if(checkbox && checkbox.checked){
      if(idx === -1) this.queryVars[arrKey].push(normVal);
    }
    else {
      if(idx !== -1) this.queryVars[arrKey].splice(idx, 1);
    }

    if(updateAjax){
      this.ajaxLoadMore(false, true);
    }
  }


  setClearButtonVisibility() {
    if(this.els.clearFiltersButton){
      if(this.queryVars.s || this.queryVars.taxQueryTaxonomies.length > 0 || this.queryVars.metaQueryFields.length > 0 || (this.queryVars.jobDepartments && this.queryVars.jobDepartments.length > 0) || (this.queryVars.jobLocations && this.queryVars.jobLocations.length > 0)){
        this.els.clearFiltersButton.removeAttribute('aria-hidden');
        this.els.clearFiltersButton.classList.add('active');
      }
      else {
        this.els.clearFiltersButton.setAttribute('aria-hidden', 'true');
        this.els.clearFiltersButton.classList.remove('active');
      }
    }
  }

  // Update current query vars on group labels, comma separating values
  updateDropDownLabelCurrentDisplay() {
    const groups = this.els.block.querySelectorAll('.post_feed__filters_group');
    groups.forEach(group => {
      const button = group.querySelector('.post_feed__filters_group_label');
      const label = group.querySelector('.post_feed__filters_group_label .current');
      const checkboxes = group.querySelectorAll('.checkbox_input');
      if(label && checkboxes.length){
        const checkedBoxes = Array.from(checkboxes).filter(cb => cb.checked);
        if(checkedBoxes.length){
          const labels = checkedBoxes.map(cb => {
            return cb.dataset.termName ? cb.dataset.termName : (cb.dataset.jobValue ? cb.dataset.jobValue : '');
          });
          label.innerText = labels.join(', ');
          label.classList.add('active');
        }
        else {
          label.innerText = '';
          label.classList.remove('active');
        }
      }
    });
  }

  /*****************************************************
   * AJAX CALL
   *****************************************************/
  ajaxLoadMore(loadMore = false, scrollToTopAfter = false) {
    // If we're not loading more posts but instead filtering posts, 
    // start a new query.
    if(!loadMore){
      this.queryVars.offset = 0;
    }
    else {
      this.queryVars.offset = this.els.cards.length;
    }

    var data = {
      action: 'ajax_filter_posts', // function to execute
      afp_nonce: afp_vars.afp_nonce, // wp_nonce
      queryVars: this.queryVars, // data used to execute new wp_query
      layout: this.layout, // layout type
    };

    document.body.classList.add('ajax_loading_posts');

    // Add spinner before button
    document.body.insertAdjacentHTML('beforeend','<div class="ajax_loading__wrap"><div class="ajax_loading__icon"></div></div>');

    // Scroll to top if needed
    if(scrollToTopAfter){
      setTimeout(() => {
        // if the block top is above the scroll top, scroll to it
        if(this.els.block.getBoundingClientRect().top < 0){
          if(smoother){
            smoother.scrollTo(this.els.block, true, "top 200px");
          }
          else {
            scrollToEl(this.els.block);
          }
        }
      }, 200);
    }

    // Show/hide clear filters button
    this.setClearButtonVisibility();

    // console.log(this.queryVars);

    // Expect JSON payload from WP's wp_send_json_*; enforce parsing via dataType
    jQuery.post(afp_vars.afp_ajax_url, data, (response) => {
      if (response) {
        // console.log(response);

        // Update cards markup
        if(response.data.cards){
          // Add new cards
          if(loadMore){
            this.els.feedWrap.insertAdjacentHTML( 'beforeend', response.data.cards );
          }
          else {
            this.els.feedWrap.innerHTML = response.data.cards;
          }
          
          // Track cards
          this.setCardElements();
          
          // For better keyboard accessibility, set focus on the "next" card, 
          // or first one if we're replacing all cards.
          const focusCard = this.queryVars.offset > 0 ? this.els.cards[this.queryVars.offset - 1] : this.els.cards[0];
          const focusCardLinks = focusCard ? focusCard.querySelectorAll('a') : null;
          if(focusCardLinks && focusCardLinks.length > 0){
            const focusLink = this.queryVars.offset > 0 ? focusCardLinks[focusCardLinks.length - 1] : focusCardLinks[0];
            focusLink.focus();
            focusLink.blur();
          }

          if(this.els.feedWrap.classList.contains('hidden')){
            this.els.feedWrap.classList.remove('hidden');
          }
        }
        else if(response.data.noResultsMarkup) {
          this.els.feedWrap.innerHTML = response.data.noResultsMarkup;
          this.setCardElements();
        }

        // Update the offset of the query vars
        this.queryVars.offset = this.els.cards.length ? this.els.cards.length : 0;

        // Determine if we should show/hide the load more button
        if(this.els.loadMoreButton){
          if(this.els.cards.length >= response.data.totalCount){
            this.els.loadMoreButton.setAttribute('disabled', '');
          }
          else if(this.els.loadMoreButton.getAttribute('disabled') !== null){
            this.els.loadMoreButton.removeAttribute('disabled');
          }
        }
      }
    }, 'json').done(() => {
    }).fail(() => {
    }).always(() => {
      document.body.classList.remove('ajax_loading_posts');
      const loadingGraphic = document.querySelector('.ajax_loading__wrap');
      loadingGraphic.remove();

      // Call window resize event to trigger scroll trigger animations if needed
      setTimeout(() => {
        watchAnimations();
        const event = new CustomEvent("resize");
        window.dispatchEvent(event);
      }, 100);
    });
  }

  // Collect the IDs of all checked meta checkboxes in this block
  getCheckedMetaCheckboxIds() {
    return Array.from(
      this.els.block.querySelectorAll('.post_feed__filters_meta_checkbox:checked')
    ).map(cb => cb.id).filter(Boolean);
  }

  // Update URL's mcb (and optional m_relation) based on current UI
  syncMetaCheckboxesToUrl() {
    if (!this.isOnlyFeedOnPage()) return;
    const url = new URL(window.location.href);

    const ids = this.getCheckedMetaCheckboxIds();
    if (ids.length > 0) {
      url.searchParams.set('mcb', ids.join(','));
      // persist relation if present on the group (optional)
      const grp = this.els.block.querySelector('.group-type-meta_query');
      const rel = (this.queryVars.metaQueryRelation ||
                  grp?.dataset?.filterCompare ||
                  url.searchParams.get('m_relation') ||
                  'AND').toUpperCase();
      url.searchParams.set('m_relation', rel);
    } else {
      url.searchParams.delete('mcb');
      url.searchParams.delete('m_relation'); // nothing selected -> drop it
    }

    window.history.replaceState({}, '', url.toString());
  }
}

export const initializePostFeeds = (event) => {
  const feeds = document.querySelectorAll('.post_feed');
  if(feeds.length){
    feeds.forEach(feed => {
      feed.postFeed = new TD_POST_FEED(feed);
    });
  }
};

function camelToKebabCase(str) {
  return str
    // Replace any lowercase letter followed by an uppercase letter with the lowercase letter, a hyphen, and the uppercase letter
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    // Convert the whole string to lowercase
    .toLowerCase();
}

function camelToUnderscoreCase(str) {
  return str
    // Replace any lowercase letter followed by an uppercase letter with the lowercase letter, a hyphen, and the uppercase letter
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    // Convert the whole string to lowercase
    .toLowerCase();
}